module.exports = __webpack_public_path__ + "img/HZ-B5056.ae994631.jpg";